import React from 'react';
import SEO from '../components/SEO';

const Privacy = () => {
  return (
    <div className="bg-[#050505] text-white" data-testid="privacy-page">
      <SEO
        title="Privacy Policy — Bronto Intelligence"
        description="Privacy policy of Bronto Intelligence Private Limited covering how we collect, use, and protect information across our platforms and website."
        path="/privacy"
      />
      <section className="relative pt-20 pb-16 px-6 lg:px-10 overflow-hidden">
        <div className="aurora-bg" />
        <div className="relative z-10 max-w-4xl mx-auto">
          <div className="text-xs font-semibold uppercase tracking-[0.25em] text-white/40 mb-6">
            Legal
          </div>
          <h1 className="text-display text-5xl md:text-7xl mb-8">Privacy Policy</h1>
          <p className="text-white/55">Last updated: {new Date().getFullYear()}</p>
        </div>
      </section>

      <section className="px-6 lg:px-10 pb-32 border-t border-white/5 pt-16">
        <div className="max-w-4xl mx-auto space-y-12 text-white/75 leading-relaxed">
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Overview</h2>
            <p>
              Bronto Intelligence Private Limited respects the privacy of users who interact with this website and the platforms operated within the Bronto ecosystem, including BrontoAI, BrontoY, MSPConnect, and Bronto Cosmos. This Privacy Policy describes how information is collected, used, and protected.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Information Collection</h2>
            <p>
              We may collect information that you voluntarily provide through forms on this website, such as contact and career inquiries. This typically includes name, email address, and the content of your message.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Use of Information</h2>
            <p>
              Information collected is used solely for the purposes of responding to inquiries, evaluating applications, and improving our services. We do not sell or rent personal information to third parties.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Cookies and Analytics</h2>
            <p>
              This website may use cookies and standard analytics tools to understand site usage. These tools collect aggregated, non-identifying information about visitor behavior.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Data Security</h2>
            <p>
              We take reasonable measures to protect the information collected through this website. However, no method of transmission or storage is completely secure.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Changes to this Policy</h2>
            <p>
              This Privacy Policy may be updated from time to time. Updates will be reflected on this page with a revised date.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Contact</h2>
            <p>
              For questions about this Privacy Policy, please use the contact form available on this website.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
